webpackJsonp([42060573973176],{

/***/ 2569:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/transition.cd53f1e9.png";

/***/ }),

/***/ 747:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Quickstart = __webpack_require__(9);
	
	var _Quickstart2 = _interopRequireDefault(_Quickstart);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _QuickstartBranch = __webpack_require__(8);
	
	var _QuickstartBranch2 = _interopRequireDefault(_QuickstartBranch);
	
	var _transition = __webpack_require__(2569);
	
	var _transition2 = _interopRequireDefault(_transition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Quickstart2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Step 5: Show Optimistic Visual Cues'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In this step we\'ll add an opacity effect to tweets to reflect when they\'re being created, updated or deleted.'
	    ),
	    _react2.default.createElement(_QuickstartBranch2.default, { branch: 'optimistic.5' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'What\'s the problem?'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'While it\'s great that we can now show tweets in the Feed immediately, there\'s currently no visual cue to distinguish between an optimistic tweet and a real tweet, and we\'re also exposing functionality like the "edit" and "delete" actions that can\'t be performed until the tweet has a real ',
	      _react2.default.createElement(
	        'cide',
	        null,
	        'id'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'How do we solve this?'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'To improve the experience, we\'re going to visually fade the tweet when it\'s being created, updated or deleted, and we\'re not going to show the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'edit'
	      ),
	      ' or ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'delete'
	      ),
	      ' links until we have confirmation that the tweet actually exists.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Add Visual Cue for Optimistic Changes'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Update the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'render()'
	      ),
	      ' method of the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'Tweet'
	      ),
	      ' component to look like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      // src/components/Tweet.js\n      import PayloadStates from \'../constants/PayloadStates\';\n      ...\n      render() {\n        const { tweet, user } = this.props;\n        const timestamp = moment(tweet.data.createdAt).fromNow().split(\' ago\')[0];\n        const isOptimistic = (\n          tweet.state === PayloadStates.CREATING ||\n          tweet.state === PayloadStates.UPDATING ||\n          tweet.state === PayloadStates.DELETING\n        );\n\n        return (\n          <li className={"list-group-item tweet" + (isOptimistic ? " transition" : "")}>\n            <div className="image-container">\n              <img\n                className="img-circle avatar"\n                src={user.data.avatar} />\n            </div>\n            <div className="content-container">\n              <h4 className="list-group-item-heading title">\n                {user.data.nickname}\n              </h4>\n              <h4 className="list-group-item-heading timestamp">\n                {\'- \' + timestamp}\n              </h4>\n              <p className="list-group-item-text text">\n                {tweet.data.text}\n              </p>\n              <IsOwner tweet={tweet}>\n                <div className="tweet-actions">\n                  <EditLink tweet={tweet} />\n                  <DeleteLink tweet={tweet} />\n                </div>\n              </IsOwner>\n            </div>\n          </li>\n        );\n      }\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In the code above, we\'re examining the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'state'
	      ),
	      ' of the tweet, and if it\'s in the process of being created, updated, or deleted, then we\'re going to apply the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'transition'
	      ),
	      ' class, which will fade the tweet and the hide the actions.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Visual Check-in'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If everything went well, your application should now look like this when tweets are being created, updated, or deleted:'
	    ),
	    _react2.default.createElement('img', { className: 'drop-shadow', src: _transition2.default }),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Code Changes'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Below is a list of files modified during this step.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'src/components/Tweet.js'
	    ),
	    _react2.default.createElement(
	      _CodeTabs2.default,
	      null,
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES5', text: '\n        import React from \'react\';\n        import createReactClass from \'create-react-class\';\n        import PropTypes from \'prop-types\';\n        import moment from \'moment\';\n        import { connect } from \'lore-hook-connect\';\n        import PayloadStates from \'../constants/PayloadStates\';\n        import EditLink from \'./EditLink\';\n        import DeleteLink from \'./DeleteLink\';\n        import IsOwner from \'./IsOwner\';\n\n        export default connect(function(getState, props) {\n          const { tweet } = props;\n\n          return {\n            user: getState(\'user.byId\', {\n              id: tweet.data.user\n            })\n          };\n        })(\n        createReactClass({\n          displayName: \'Tweet\',\n\n          propTypes: {\n            tweet: PropTypes.object.isRequired,\n            user: PropTypes.object.isRequired\n          },\n\n          render() {\n            const { tweet, user } = this.props;\n            const timestamp = moment(tweet.data.createdAt).fromNow().split(\' ago\')[0];\n            const isOptimistic = (\n              tweet.state === PayloadStates.CREATING ||\n              tweet.state === PayloadStates.UPDATING ||\n              tweet.state === PayloadStates.DELETING\n            );\n\n            return (\n              <li className={"list-group-item tweet" + (isOptimistic ? " transition" : "")}>\n                <div className="image-container">\n                  <img\n                    className="img-circle avatar"\n                    src={user.data.avatar} />\n                </div>\n                <div className="content-container">\n                  <h4 className="list-group-item-heading title">\n                    {user.data.nickname}\n                  </h4>\n                  <h4 className="list-group-item-heading timestamp">\n                    {\'- \' + timestamp}\n                  </h4>\n                  <p className="list-group-item-text text">\n                    {tweet.data.text}\n                  </p>\n                  <IsOwner tweet={tweet}>\n                    <div className="tweet-actions">\n                      <EditLink tweet={tweet} />\n                      <DeleteLink tweet={tweet} />\n                    </div>\n                  </IsOwner>\n                </div>\n              </li>\n            );\n          }\n\n        })\n        );\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES6', text: '\n        import React from \'react\';\n        import PropTypes from \'prop-types\';\n        import moment from \'moment\';\n        import { connect } from \'lore-hook-connect\';\n        import PayloadStates from \'../constants/PayloadStates\';\n        import EditLink from \'./EditLink\';\n        import DeleteLink from \'./DeleteLink\';\n        import IsOwner from \'./IsOwner\';\n\n        class Tweet extends React.Component {\n\n          render() {\n            const { tweet, user } = this.props;\n            const timestamp = moment(tweet.data.createdAt).fromNow().split(\' ago\')[0];\n            const isOptimistic = (\n              tweet.state === PayloadStates.CREATING ||\n              tweet.state === PayloadStates.UPDATING ||\n              tweet.state === PayloadStates.DELETING\n            );\n\n            return (\n              <li className={"list-group-item tweet" + (isOptimistic ? " transition" : "")}>\n                <div className="image-container">\n                  <img\n                    className="img-circle avatar"\n                    src={user.data.avatar} />\n                </div>\n                <div className="content-container">\n                  <h4 className="list-group-item-heading title">\n                    {user.data.nickname}\n                  </h4>\n                  <h4 className="list-group-item-heading timestamp">\n                    {\'- \' + timestamp}\n                  </h4>\n                  <p className="list-group-item-text text">\n                    {tweet.data.text}\n                  </p>\n                  <IsOwner tweet={tweet}>\n                    <div className="tweet-actions">\n                      <EditLink tweet={tweet} />\n                      <DeleteLink tweet={tweet} />\n                    </div>\n                  </IsOwner>\n                </div>\n              </li>\n            );\n          }\n\n        }\n\n        Tweet.propTypes = {\n          tweet: PropTypes.object.isRequired,\n          user: PropTypes.object.isRequired\n        };\n\n        export default connect(function(getState, props) {\n          const tweet = props.tweet;\n\n          return {\n            user: getState(\'user.byId\', {\n              id: tweet.data.user\n            })\n          };\n        })(Tweet);\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ESNext', text: '\n        import React from \'react\';\n        import PropTypes from \'prop-types\';\n        import moment from \'moment\';\n        import { connect } from \'lore-hook-connect\';\n        import PayloadStates from \'../constants/PayloadStates\';\n        import EditLink from \'./EditLink\';\n        import DeleteLink from \'./DeleteLink\';\n        import IsOwner from \'./IsOwner\';\n\n        @connect(function(getState, props) {\n          const tweet = props.tweet;\n\n          return {\n            user: getState(\'user.byId\', {\n              id: tweet.data.user\n            })\n          };\n        })\n        class Tweet extends React.Component {\n\n          static propTypes = {\n            tweet: PropTypes.object.isRequired,\n            user: PropTypes.object.isRequired\n          };\n\n          render() {\n            const { tweet, user } = this.props;\n            const timestamp = moment(tweet.data.createdAt).fromNow().split(\' ago\')[0];\n            const isOptimistic = (\n              tweet.state === PayloadStates.CREATING ||\n              tweet.state === PayloadStates.UPDATING ||\n              tweet.state === PayloadStates.DELETING\n            );\n\n            return (\n              <li className={"list-group-item tweet" + (isOptimistic ? " transition" : "")}>\n                <div className="image-container">\n                  <img\n                    className="img-circle avatar"\n                    src={user.data.avatar} />\n                </div>\n                <div className="content-container">\n                  <h4 className="list-group-item-heading title">\n                    {user.data.nickname}\n                  </h4>\n                  <h4 className="list-group-item-heading timestamp">\n                    {\'- \' + timestamp}\n                  </h4>\n                  <p className="list-group-item-text text">\n                    {tweet.data.text}\n                  </p>\n                  <IsOwner tweet={tweet}>\n                    <div className="tweet-actions">\n                      <EditLink tweet={tweet} />\n                      <DeleteLink tweet={tweet} />\n                    </div>\n                  </IsOwner>\n                </div>\n              </li>\n            );\n          }\n\n        }\n\n        export default Tweet;\n        ' })
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Next Steps'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In the next section we\'ll ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '../step-6/' },
	        'hide tweets that have been deleted'
	      ),
	      '.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-quickstart-optimistic-step-5-js-32ea4b8acef9490d581b.js